import { takeEvery, put, call, take, select } from 'redux-saga/effects'
import store from '../store'
import { apiManualPost, apiManualRequest } from '../utils/request'
import {
  loadOpenForWorkSuccess,
  loadOpenForWorkFailed,
  updateOpenForWorkFailed,
  updateOpenForWorkSuccess,
  getAreaOfExpertiseSuccess,
  getAreaOfWorkSuccess,
  notOpenForWorkFailed,
  notOpenForWorkSuccess,
  loadOpenForWorkStart,
  getAllAssignmentsSuccess,
  getAllAssignmentsFailed,
  searchAssignmentSuccess,
  searchAssignmentFailed,
  sendApplicationSuccess,
  sendApplicationFailed,
  getAssignmentOfferToEmailSuccess,
  getAssignmentOfferToEmailFailed,
  getAllAssignments,
  trackApplicationSuccess,
  trackApplicationFailed,
  trackApplication,
  rejectAssignmentSuccess,
  getAssignmentOfferToEmail,
  getApplicationProfileSuccess,
  getApplicationProfileFailed,
  signAndSendAssignmentSuccess,
  signAndSendAssignmentFailed,
  loadSignSend,
  closeLoadSignSend,
  getWorkshiftUserSuccess,
  getWorkshiftUserFailed,
  getBillableHourUserSuccess,
  getBillableHourUserFailed,
  updateUserWorkshiftSuccess,
  updateUserWorkshiftFailed,
  getWorkshiftUser,
  requestEditActualHourSuccess,
  requestEditActualHourFailed,
  // saveInvoiceDraft,
  getBillableHourUser,
  getEmployerWorkshiftSuccess,
  getEmployerWorkshiftFailed,
  getJournalSuccess,
  getJournalFailed,
  getJournalEditSuccess,
  getJournalEditFailed,
  deleteJournalSuccess,
  deleteJournalFailed,
  getJournal,
  addJournalDetailSuccess,
  addJournalDetailFailed,
  updateJournalDetailSuccess,
  updateJournalDetailFailed,
  pinAssignmentSuccess,
  pinAssignmentFailed,
  pinApplicationSuccess,
  pinApplicationFailed,
  pinWorkShiftSuccess,
  pinWorkShiftFailed
} from '../actions'
import { updateFormValues } from '../form'
import {
  API_SERVER,
  LOAD_OPEN_FOR_WORK_START,
  UPDATE_OPEN_FOR_WORK,
  GET_AREA_OF_EXPERTISE,
  GET_AREA_OF_WORK,
  NOT_OPEN_FOR_WORK,
  GET_ALL_ASSIGNMENTS,
  SEARCH_ASSIGNMENT,
  SEND_APPLICATION,
  TRACK_APPLICATION,
  GET_ASSIGNMENT_OFFERED_TO_EMAIL,
  REJECT_ASSIGNMENT,
  GET_APPLICATION_PROFILE,
  SIGN_AND_SEND_ASSIGNMENT,
  GET_WORKSHIFT_USER,
  UPDATE_USER_WORKSHIFT,
  REQUEST_EDIT_ACTUAL_HOUR,
  GET_BILLABLE_HOUR_USER,
  GET_EMPLOYER_WORKSHIFT,
  GET_JOURNAL,
  GET_JOURNAL_EDIT,
  DELETE_JOURNAL,
  ADD_JOURNAL_DETAIL,
  UPDATE_JOURNAL_DETAIL,
  UPDATE_VIEW_ASSIGNMENT,
  PIN_ASSIGNMENT,
  UPDATE_VIEW_APPLICATION,
  PIN_APPLICATION,
  UPDATE_VIEW_WORKSHIFT,
  PIN_WORKSHIFT
} from '../constants'
import { createUploadFileChannel_openForWork } from '../utils/request'
import {
  getFirstName,
  getLastName,
  getLoggedInEmail,
  getUserType,
  getUuid
} from '../selectors/client.selector'
import {
  getApplicationData,
  getIsEditTimeReportData,
  getJournalId,
  getOpenForWorkForm,
  getOpenWorkAttachments,
  getPhoneNumber,
  getProfileData,
  getUserData
} from '../selectors/openForWork.selector'
import { rejectAssignment } from '../selectors/application.selector'
import moment from 'moment'
import {
  contractContent,
  convertPortfolioNameLinks,
  generateProfileRatings,
  groupWorkshiftById,
  shrinkString
} from '../utils/openForWork.utils'

/**
 * @author Huong Nguyen
 */

function* loadOpenForWorkSaga() {
  try {
    const uuid = store.getState().client.user.data[2]
    if (!!uuid) {
      const url = `${API_SERVER}/GetWorkbyUserId/${uuid}`

      const result = yield call(apiManualRequest, url)
      const resultParsed = JSON.parse(result.data)

      if (resultParsed) {
        // take the last update
        const lastResultParsed = resultParsed[resultParsed.length - 1]

        // letter, CV title, image
        const imageFile = lastResultParsed.OpenWorkAttachments?.filter(
          (el) => el.AttachmentType === 1
        )
        const letterFile = lastResultParsed.OpenWorkAttachments?.filter(
          (el) => el.AttachmentType === 2
        )
        const CVfile = lastResultParsed.OpenWorkAttachments?.filter(
          (el) => el.AttachmentType === 3
        )

        const formValues = {}
        formValues.Id = lastResultParsed.Id
        formValues.IsNotOpenForWork = lastResultParsed.IsOpenForWork
          ? false
          : true
        formValues.RetrieveJobs = lastResultParsed.RetrieveJobs
        formValues.notAcceptRatings = lastResultParsed.AcceptRatings
          ? false
          : true
        formValues.AreaOf_Expertise = stringToArray(
          lastResultParsed.AreaOfExpertise
        )
        formValues.AreaOf_Work = stringToArray(lastResultParsed.AreaOfWork)
        formValues.letter_file =
          letterFile.length > 0 &&
          letterFile[0]?.Title !== null &&
          letterFile[0]?.Title !== undefined
            ? shrinkString(letterFile[0]?.Title, 20, 10)
            : '' // file name
        formValues.inputLetter = letterFile[0]?.FilePath || '' // file path
        formValues.CV_file =
          CVfile.length > 0 &&
          CVfile[0]?.Title !== null &&
          CVfile[0]?.Title !== undefined
            ? shrinkString(CVfile[0]?.Title, 20, 10)
            : '' // file name
        formValues.inputCV = CVfile[0]?.FilePath || '' // file path
        formValues.inputImage = imageFile[0]?.FilePath || ''
        formValues.OpenWorkAttachments = ensureAttachmentTypes(
          lastResultParsed.OpenWorkAttachments
        )
        formValues.experienceInputRow = lastResultParsed.OpenWorkExperience
        formValues.linkedin_url =
          lastResultParsed.linkedin_url === null
            ? ''
            : lastResultParsed.linkedin_url
        formValues.info_consent_allowed = lastResultParsed.info_consent_allowed

        for (let i = 0; i < formValues.experienceInputRow.length; i++) {
          convertDateValues(formValues.experienceInputRow[i])
        }

        // convert null values to empty string at experienceInputRow
        formValues.experienceInputRow.forEach((row) => {
          for (const key in row) {
            if (row[key] === null) {
              row[key] = ''
            }
          }
        })

        formValues.linkRow = lastResultParsed.OpenWorkPortfolioLinks.map(
          (el) => ({
            link_title: el.Title,
            link_url: el.Url
          })
        )
        formValues.role_title = lastResultParsed?.Title || ''
        formValues.short_des = lastResultParsed.ShortDescription

        yield put(loadOpenForWorkSuccess(formValues))
        yield put(updateFormValues('openforwork', formValues))
      }
    }
  } catch (error) {
    yield put(loadOpenForWorkFailed(error))
  }
}

function ensureAttachmentTypes(arr) {
  const attachmentTypes = [1, 2, 3]

  attachmentTypes.forEach((type) => {
    if (!arr.some((item) => item.AttachmentType === type)) {
      arr.push({
        AttachmentType: type,
        FileType: null,
        Title: null,
        data: null
      })
    }
  })

  return arr
}

function convertDateValues(row) {
  if (row.StartDate !== null) {
    const startDate = new Date(row.StartDate)
    row.start_month = startDate.getMonth() + 1
    row.start_year = startDate.getFullYear()
  } else {
    row.start_month = 0
    row.start_year = 0
  }

  if (row.EndDate !== null) {
    const endDate = new Date(row.EndDate)
    row.end_month = endDate.getMonth() + 1
    row.end_year = endDate.getFullYear()
  } else {
    row.end_month = 0
    row.end_year = 0
  }
}

function* updateOpenForWorkSaga({ formValues, files }) {
  try {
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const isEdit = store.getState().openForWork.isEdit
    const workId = store.getState().openForWork.workId

    const body = {
      UserId: userType == 2 ? selectedUser.uuid : uuid,
      IsOpenForWork: formValues.IsNotOpenForWork === true ? 0 : 1,
      RetrieveJobs: formValues.RetrieveJobs === true ? 1 : 0,
      AcceptRatings: formValues.notAcceptRatings === true ? 0 : 1,
      AreaOfExpertise: arrayToString(
        formValues?.AreaOf_Expertise ? formValues.AreaOf_Expertise : []
      ),
      AreaOfWork: arrayToString(
        formValues?.AreaOf_Work ? formValues.AreaOf_Work : []
      ),
      OpenWorkExperience: !!formValues.experienceInputRow
        ? formValues.experienceInputRow.filter((el) => el.CompanyName !== '')
        : [],
      Status: 0,
      linkedin_url: formValues.linkedin_url,
      info_consent_allowed: formValues.info_consent_allowed,
      title: formValues.role_title,
      shortDescription: formValues.short_des,
      OpenWorkPortfolioLinks: formValues?.linkRow?.map((el) => ({
        Title: el.link_title,
        Url: el.link_url
      }))
    }

    //update body to send when update work application
    if (isEdit === true) {
      body.Id = workId
      body.Status = 1
      for (let i = 0; i < body.OpenWorkExperience.length; i++) {
        const start_date = new Date(
          body.OpenWorkExperience[i].start_year,
          body.OpenWorkExperience[i].start_month
        )
        const end_date = new Date(
          body.OpenWorkExperience[i].end_year,
          body.OpenWorkExperience[i].end_month
        )
        body.OpenWorkExperience[i].Id =
          !!body.OpenWorkExperience[i].Id !== 0
            ? body.OpenWorkExperience[i].Id
            : 0
        body.OpenWorkExperience[i].OpenWorkId = workId
        if (
          body.OpenWorkExperience[i].start_month === 0 &&
          body.OpenWorkExperience[i].start_year === 0
        ) {
          body.OpenWorkExperience[i].StartDate = ''
        } else {
          body.OpenWorkExperience[i].StartDate = start_date
        }
        if (
          body.OpenWorkExperience[i].end_month === 0 &&
          body.OpenWorkExperience[i].end_year === 0
        ) {
          body.OpenWorkExperience[i].EndDate = ''
        } else {
          body.OpenWorkExperience[i].EndDate = end_date
        }
      }
    }

    const url = `${API_SERVER}/CreateNewWork`
    const channel = yield call(
      createUploadFileChannel_openForWork,
      url,
      files,
      body
    )
    while (true) {
      const { err, success, data } = yield take(channel)
      if (err) {
        yield put(updateOpenForWorkFailed(err))
        // console.log('UPDATE OPEN FOR WORK FAILED 1')
      }
      if (success) {
        if (
          JSON.parse(data) ===
          '"An error occurred while updating the entries. See the inner exception for details."'
        ) {
          yield put(updateOpenForWorkFailed(err))
        } else {
          yield put(updateOpenForWorkSuccess(success))
        }
        yield put(loadOpenForWorkStart())
      }
    }
  } catch (error) {
    yield put(updateOpenForWorkFailed(error))
    // console.log('UPDATE OPEN FOR WORK FAILED 2')
  }
}

// Convert array to sring
// Example: [1, 2, 3] to "1, 2, 3"
function arrayToString(arr) {
  if (arr.length === 0) {
    return ''
  } else {
    return arr.join(',')
  }
}

function stringToArray(str) {
  if (str === '') {
    return []
  } else {
    return str.split(',').map(Number)
  }
}

// Not open for work
function* notOpenForWorkSaga() {
  try {
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const openForWorkFormValues = yield select(getOpenForWorkForm)
    const openWorkAttachments = yield select(getOpenWorkAttachments)

    const isEdit = store.getState().openForWork.isEdit
    const workId = store.getState().openForWork.workId

    const body = {
      UserId: userType == 2 ? selectedUser.uuid : uuid,
      IsOpenForWork: 0,
      RetrieveJobs: 0,
      AcceptRatings: openForWorkFormValues.notAcceptRatings === true ? 0 : 1,
      AreaOfExpertise: arrayToString(
        openForWorkFormValues?.AreaOf_Expertise
          ? openForWorkFormValues.AreaOf_Expertise
          : []
      ),
      AreaOfWork: arrayToString(
        openForWorkFormValues?.AreaOf_Work
          ? openForWorkFormValues.AreaOf_Work
          : []
      ),
      OpenWorkExperience: !!openForWorkFormValues.experienceInputRow
        ? openForWorkFormValues.experienceInputRow.filter(
            (el) => el.CompanyName !== ''
          )
        : [],
      Status: 0,
      linkedin_url: openForWorkFormValues.linkedin_url,
      info_consent_allowed: openForWorkFormValues.info_consent_allowed,
      title: openForWorkFormValues.role_title,
      shortDescription: openForWorkFormValues.short_des,
      OpenWorkPortfolioLinks: openForWorkFormValues?.linkRow?.map((el) => ({
        Title: el.link_title,
        Url: el.link_url
      }))
    }

    //update body to send when update work application
    if (isEdit === true) {
      body.Id = workId
      body.Status = 1
      for (let i = 0; i < body.OpenWorkExperience.length; i++) {
        const start_date = new Date(
          body.OpenWorkExperience[i].start_year,
          body.OpenWorkExperience[i].start_month
        )
        const end_date = new Date(
          body.OpenWorkExperience[i].end_year,
          body.OpenWorkExperience[i].end_month
        )
        body.OpenWorkExperience[i].Id =
          !!body.OpenWorkExperience[i].Id !== 0
            ? body.OpenWorkExperience[i].Id
            : 0
        body.OpenWorkExperience[i].OpenWorkId = workId
        body.OpenWorkExperience[i].StartDate = start_date
        body.OpenWorkExperience[i].EndDate = end_date
      }
    }

    const url = `${API_SERVER}/CreateNewWork`
    const channel = yield call(
      createUploadFileChannel_openForWork,
      url,
      openWorkAttachments,
      body
    )
    while (true) {
      const { err, success, data } = yield take(channel)
      if (err) {
        yield put(notOpenForWorkFailed(err))
      }
      if (success) {
        if (
          JSON.parse(data) ===
          'An error occurred while updating the entries. See the inner exception for details.'
        ) {
          yield put(notOpenForWorkFailed(err))
        } else {
          yield put(notOpenForWorkSuccess(success))
        }
        yield put(loadOpenForWorkStart())
      }
    }
  } catch (error) {
    yield put(notOpenForWorkFailed(error))
  }
}

function* getAreaOfExpertiseSaga() {
  try {
    const url = `${API_SERVER}/GetAreaOfExpertise/en`
    const result = yield apiManualRequest(url)
    const parRes = JSON.parse(result.data)
    yield put(getAreaOfExpertiseSuccess(parRes))
  } catch (error) {}
}

function* getAreaOfWorkSaga() {
  try {
    const url = `${API_SERVER}/GetAreaOfWork/en`
    const result = yield apiManualRequest(url)
    const parRes = JSON.parse(result.data)
    yield put(getAreaOfWorkSuccess(parRes))
  } catch (error) {}
}

// Get all assignments
function* getAllAssignmentsSaga() {
  try {
    const url = `${API_SERVER}/SearchAssignmentApplicantDetails`
    const body = JSON.stringify({
      employerdetails: [
        {
          jobtitle: '',
          industrytype: null,
          companyname: '',
          city: '',
          PinnedAssignment: false,
          status: 0
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getAllAssignmentsSuccess(resultParsed))
    }
  } catch (error) {
    yield put(getAllAssignmentsFailed(error))
  }
}
// Get assignment offer by company
function* getAssignmentOfferedSaga() {
  try {
    const url = `${API_SERVER}/GetOfferedAssignmentAgreementDetails`
    const email = yield select(getLoggedInEmail)
    const body = JSON.stringify({
      offeredentrepreneuremail: email
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getAssignmentOfferToEmailSuccess(resultParsed))
    } else {
      yield put(getAssignmentOfferToEmailFailed())
    }
  } catch (error) {
    yield put(getAssignmentOfferToEmailFailed(error))
  }
}

// Search assignments
function* searchAssignmentSaga({ values }) {
  try {
    const url = `${API_SERVER}/SearchAssignmentApplicantDetails`
    const body = JSON.stringify({
      employerdetails: [
        {
          jobtitle: values?.job_title ? values.job_title : '',
          industrytype: values?.industry ? values.industry.join(',') : null,
          companyname: values?.company_name ? values.company_name : '',
          city: values?.city_name ? values.city_name : '',
          PinnedAssignment: values.pinned,
          status: values.status
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(
        searchAssignmentSuccess(resultParsed, values.pageSize, JSON.parse(body))
      )
    }
  } catch (error) {
    yield put(searchAssignmentFailed(error))
  }
}

// Set assignment as viewed
function* updateViewAssignmentSaga({ assignment_id, uuid }) {
  try {
    const url = `${API_SERVER}/AssignmentUserNotification`
    const email = yield select(getLoggedInEmail)

    const body = JSON.stringify({
      assignmentNotifyDetails: [
        {
          uuid: uuid,
          assignmentid: assignment_id,
          entrepreneursEmail: email,
          isAssignmentReviewed: true
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)
    if (
      result.data === 'Assignment notification details are added successfully'
    ) {
      yield put(getAllAssignments())
    }
  } catch (error) {}
}

// Pin assignment
function* pinAssignmentSaga({ assignment_id }) {
  try {
    const url = `${API_SERVER}/AddUserPinnedAssignmentDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      uuid: uuid,
      assignmentid: assignment_id
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Pinned assignment details are added successfully') {
      yield put(pinAssignmentSuccess(result.data))
    } else {
      yield put(pinAssignmentFailed(result.data))
    }
    yield put(trackApplication())
    yield put(getAllAssignments())
  } catch (error) {
    yield put(pinAssignmentFailed(error))
  }
}

// Set application as viewed
function* updateViewApplicationSaga({ agreement_id }) {
  try {
    const url = `${API_SERVER}/UpdateSignatureAssignmentDetails`

    const body = JSON.stringify({
      agreementId: agreement_id,
      isApplicationViewed: 1
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Viewed application details are updated successfully') {
      yield put(getAssignmentOfferToEmail())
    }
  } catch (error) {}
}

// Pin offered assignment
function* pinApplicationSaga({ agreement_id }) {
  try {
    const url = `${API_SERVER}/AddPinnedApplicationDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      appliedpersonuuid: uuid,
      employerdetails: [
        {
          assignmentagreementid: agreement_id
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Pinned application details are added successfully') {
      yield put(pinApplicationSuccess(result.data))
    } else {
      yield put(pinApplicationFailed(result.data))
    }
    yield put(trackApplication())
    yield put(getAssignmentOfferToEmail())
  } catch (error) {
    yield put(pinApplicationFailed(error))
  }
}

// Send application
function* sendApplicationSaga({ job_info, ratingData }) {
  try {
    const url = `${API_SERVER}/AddAssignmentApplicantDetails`
    const uuid = yield select(getUuid)
    const email = yield select(getLoggedInEmail)
    const firstName = yield select(getFirstName)
    const lastName = yield select(getLastName)
    const phoneNumber = yield select(getPhoneNumber)
    const userData = yield select(getProfileData)

    const applicationData = yield select(getApplicationData)
    const experienceInputRow = applicationData.experienceInputRow
    let workexperience = []
    if (experienceInputRow?.length > 0) {
      workexperience = experienceInputRow.map((el, index) => {
        return `<div style={{ paddingBottom: '20px' }} key=${index}><p>${el.JobTitle} - ${el.start_month}/${el.start_year} to ${el.end_month}/${el.end_year}</p><p>${el.CompanyName}, ${el.Location}</p><p>${el.Responsibilities}</p><p>${el.KeyAchievements}</p><hr /></div>`
      })
    }
    const keyachievement = experienceInputRow?.map((el) => el.KeyAchievements)

    const body = JSON.stringify({
      appliedpersonuuid: uuid,
      appliedpersonemail: email,
      appliedjobid: job_info.assignment_id,
      applicantfirstname: firstName,
      entrepreneurapplicationstatus: 'application sent',
      jobtitle: job_info.job_title,
      employeremail: job_info.company_email,
      employerdetails: [
        {
          companyname: job_info.company_name
        }
      ],
      applicantprofiles: [
        {
          name: firstName + ' ' + lastName,
          email: email,
          phonenumber: applicationData.info_consent_allowed ? phoneNumber : '',
          address: applicationData.info_consent_allowed ? userData.address : '',
          zipcode: applicationData.info_consent_allowed
            ? userData.zip_code
            : '',
          city: applicationData.info_consent_allowed ? userData.city : '',
          ProfileRating: generateProfileRatings(ratingData),
          areaofexpertise: arrayToString(
            applicationData?.AreaOf_Expertise
              ? applicationData.AreaOf_Expertise
              : []
          ),
          areaofwork: arrayToString(
            applicationData?.AreaOf_Work ? applicationData.AreaOf_Work : []
          ),
          workexperience:
            workexperience?.length !== 0 ? workexperience?.join(' ') : '',
          keyachievement:
            keyachievement?.length !== 0 ? keyachievement?.join(' ') : '',
          profileimagepath: applicationData.inputImage,
          cvpath:
            applicationData.inputCV === undefined
              ? null
              : applicationData.inputCV,
          coverletterpath:
            applicationData.inputLetter === undefined
              ? null
              : applicationData.inputLetter,
          linkedinprofileurl: applicationData.linkedin_url,
          title: applicationData.role_title,
          shortDescription: applicationData.short_des,
          portfolioNameLinks: convertPortfolioNameLinks(applicationData.linkRow)
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Applicant details are added successfully') {
      yield put(sendApplicationSuccess(result.data))
    }
  } catch (error) {
    yield put(sendApplicationFailed(error))
  }
}

// Get all assignments that have been applied
function* trackApplicationSaga() {
  try {
    const url = `${API_SERVER}/TrackApplicationDetails`
    const email = yield select(getLoggedInEmail)

    const body = JSON.stringify({
      offeredentrepreneuremail: email
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(trackApplicationSuccess(resultParsed))
      yield put(getAllAssignments())
    }
  } catch (error) {
    yield put(trackApplicationFailed(error))
  }
}

// Reject assignment that offered by company
function* rejectAssignmentSaga({ reason, data }) {
  try {
    const url = `${API_SERVER}/UpdateSignatureAssignmentDetails`
    const rejectAssignmentData =
      reason === 'Assignment expired!' ? data : yield select(rejectAssignment)
    const firstname = yield select(getFirstName)
    const email = yield select(getLoggedInEmail)
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      agreementid: rejectAssignmentData.agreement_id,
      applicantfirstname: firstname,
      offeredentrepreneuremail: email,
      offeredagreementstatusentrepreneur: 'Offer rejected by entrepreneur',
      offeredemployeremail: rejectAssignmentData.email,
      oldcontracturl: rejectAssignmentData.contract_path,
      declinesignreason: reason,
      employerdetails: [
        {
          contactname: rejectAssignmentData.contact_name
        }
      ],
      appliedpersonuuid: uuid,
      appliedjobid: rejectAssignmentData.assignment_job_id
    })

    const result = yield call(apiManualPost, url, body)
    if (
      result.data === 'Rejected agreement and email has been sent successfully'
    ) {
      yield put(rejectAssignmentSuccess(result.data))

      yield put(trackApplication())
      yield put(getAssignmentOfferToEmail())
    }
  } catch (error) {}
}

// Get application profile data
function* getApplicationProfileSaga({ values }) {
  try {
    const url = `${API_SERVER}/GetAppliedProfileDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      appliedpersonuuid: uuid,
      appliedjobid: values.assignment_id
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)

    if (result.data) {
      yield put(getApplicationProfileSuccess(resultParsed))
    }
  } catch (error) {
    yield put(getApplicationProfileFailed(error))
  }
}

// Sign and send the assignment offer
function* signAndSendAssignmentSaga({
  offerData,
  trim
  // draftInvoiceValues
}) {
  try {
    yield put(loadSignSend())
    const url = `${API_SERVER}/UpdateSignatureAssignmentDetails`
    const firstName = yield select(getFirstName)
    const lastName = yield select(getLastName)
    const email = yield select(getLoggedInEmail)
    const userData = yield select(getUserData)
    const profileData = yield select(getProfileData)
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      agreementid: offerData.agreement_id,
      applicantfirstname: firstName,
      offeredentrepreneuremail: email,
      offeredagreementstatusentrepreneur: 'Offer accepted by entrepreneur',
      offeredemployeremail: offerData.email,
      // oldcontracturl: offerData.contract_path,
      employerdetails: [
        {
          contactname: offerData.contact_name,
          email: offerData.email,
          offerlename: firstName + lastName,
          uuid: offerData.uuid,
          offerlezipcode: profileData.zip_code,
          offerlecity: profileData.city,
          assignmentbegins: moment(offerData.assignment_begins).format(
            'MM.DD.YYYY'
          ),
          assignmentends:
            offerData.assignment_ends !== null
              ? moment(offerData.assignment_ends).format('MM.DD.YYYY')
              : null,
          assignmenttype: offerData.assignment_type,
          salarymodel: offerData.salary_model,
          additionalterms: offerData.additional_terms,
          expensefee: offerData.inc_expensefee,
          paymentterms: offerData.payment_terms,
          hourlyrate: offerData.hourly_rate,
          tilaajasign: offerData.employer_sign,
          assignmentcontent: offerData.assignment_contents,
          entrepreneursemail: userData.email,
          entrepreneursign: trim,
          employersigndate: moment(offerData.employer_sign_date).format(
            'MM.DD.YYYY'
          ),
          contractlanguage: offerData.contract_path.includes('eng')
            ? 'eng'
            : 'fi',
          amount: offerData.amount,
          ContractInfo: contractContent(
            offerData.assignment_ends,
            offerData.contract_path.includes('eng')
          )
        }
      ],
      appliedpersonuuid: uuid,
      appliedjobid: offerData.assignment_job_id
    })
    const result = yield call(apiManualPost, url, body)
    if (
      result.data ===
      'Assignment agreement signed and email has been sent successfully'
    ) {
      yield put(closeLoadSignSend())
      yield put(signAndSendAssignmentSuccess(result.data))
      yield put(trackApplication())
      yield put(getAssignmentOfferToEmail())
      // yield put(saveInvoiceDraft(draftInvoiceValues))
    } else {
      yield put(closeLoadSignSend())
      yield put(signAndSendAssignmentFailed(error))
    }
  } catch (error) {
    yield put(signAndSendAssignmentFailed(error))
  }
}

function* getWorkshiftUserSaga() {
  try {
    const url = `${API_SERVER}/GetUserWorkShiftsDetails`
    const email = yield select(getLoggedInEmail)
    const body = JSON.stringify({
      email: email
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getWorkshiftUserSuccess(resultParsed))
    } else {
      yield put(getWorkshiftUserFailed())
    }
  } catch (error) {
    yield put(getWorkshiftUserFailed(error))
  }
}

function* updateUserWorkshiftSaga({ values, status }) {
  const workshifts = groupWorkshiftById(values, status)

  try {
    const url = `${API_SERVER}/UpdateUserWorkShiftDetails`
    const body = JSON.stringify({
      workshifts: workshifts,
      email: values[0].offershift_to
    })

    const result = yield call(apiManualPost, url, body)
    if (
      result.data === 'Entrepreneurs work shift status is updated successfully'
    ) {
      yield put(updateUserWorkshiftSuccess(result.data))
    } else {
      yield put(updateUserWorkshiftFailed(result.data))
    }
    yield put(getWorkshiftUser())
    yield put(getBillableHourUser())
  } catch (error) {
    yield put(updateUserWorkshiftFailed())
  }
}

function* getBillableHourUserSaga() {
  try {
    const url = `${API_SERVER}/GetUserBilledWorkShiftDetails`
    const email = yield select(getLoggedInEmail)
    const body = JSON.stringify({
      email: email
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getBillableHourUserSuccess(resultParsed))
    } else {
      yield put(getBillableHourUserFailed())
    }
  } catch (error) {
    yield put(getBillableHourUserFailed(error))
  }
}

// Set workshift as viewed
function* updateViewWorkshiftSaga({ workshift_itemid }) {
  try {
    const url = `${API_SERVER}/UpdateUserWorkShiftDetails`

    const body = JSON.stringify({
      workShifts: [
        {
          workShiftItems: [
            {
              workShiftItemId: workshift_itemid
            }
          ],
          isViewedWorkShift: 1
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)
    if (
      result.data === 'Viewed user work shift details are updated successfully'
    ) {
      yield put(getWorkshiftUser())
    }
  } catch (error) {}
}

function* pinWorkShiftSaga({ id }) {
  try {
    const url = `${API_SERVER}/AddUserPinnedWorkshiftDetails`
    // const uuid = yield select(getUuid)
    const body = JSON.stringify({
      // uuid: uuid,
      workshiftitems: [
        {
          workshiftitemid: id
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Pinned workshift details are added successfully') {
      yield put(pinWorkShiftSuccess(result.data))
    } else {
      yield put(pinWorkShiftFailed(result.data))
    }
    yield put(getWorkshiftUser())
    yield put(getBillableHourUser())
  } catch (error) {
    yield put(pinWorkShiftFailed(error))
  }
}

// Request edit actually hours
function* requestEditActualHourSaga({ values, data }) {
  try {
    const url = `${API_SERVER}/UpdateWorkShiftHoursDetails`
    const body = JSON.stringify({
      workshifts: [
        {
          workshiftid: data.workshift_id,
          workshiftstatus: data.workshift_status,
          actualshiftstarttime: values.startTime,
          actualshiftendtime: values.endTime,
          additionalinfo:
            values.note === '' ||
            values.note === null ||
            values.note === undefined
              ? 'As scheduled'
              : values.note,
          workshiftitems: [
            {
              workshiftitemid: data.workshift_itemid
            }
          ]
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    if (
      result.data === 'User work shift hours details are saved successfully' ||
      result.data === 'User work shift hours are updated successfully'
    ) {
      yield put(requestEditActualHourSuccess(result.data))
    } else {
      yield put(requestEditActualHourFailed())
    }
    yield put(getWorkshiftUser())
    yield put(getBillableHourUser())
  } catch (error) {
    yield put(requestEditActualHourFailed(error))
  }
}

function* getEmployerWorkshiftSaga() {
  try {
    const url = `${API_SERVER}/SearchWorkShiftCustomers`
    const email = yield select(getLoggedInEmail)

    const body = JSON.stringify({
      email: email
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data) {
      yield put(getEmployerWorkshiftSuccess(JSON.parse(result.data)))
    } else {
      yield put(getEmployerWorkshiftFailed(result.data))
    }
  } catch (error) {
    yield put(getEmployerWorkshiftFailed(error))
  }
}

function* getJournalSaga() {
  try {
    const url = `${API_SERVER}/GetUserWorkShiftsJournalDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getJournalSuccess(resultParsed))
    } else {
      yield put(getJournalFailed(result.data))
    }
  } catch (error) {
    yield put(getWorkshiftUserFailed(error))
  }
}

function* addJournalDetailSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/AddUserWorkShiftJournalDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      user: [{ uuid: uuid }],
      taskdescription: formValues.task_description,
      workshiftjournalitems: formValues.dateTimeRows.map((item) => ({
        shiftdate: moment(item.date).format('YYYY-MM-DD'),
        shiftstarttime: item.startTime,
        shiftendtime: item.endTime,
        shiftworkedhours: item.totalHour,
        amount: item.amount === '' ? 0 : item.amount,
        shiftcomments: item.additionalInfo,
        sumtotalamount: item.totalAmount
      }))
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Work shift journal details are added successfully') {
      yield put(addJournalDetailSuccess(result.data))
    } else {
      yield put(addJournalDetailFailed(result.data))
    }
    yield put(getJournal())
  } catch (error) {
    yield put(addJournalDetailFailed(error))
  }
}

function* getJournalEditSaga({ id }) {
  try {
    const url = `${API_SERVER}/GetUserEditWorkShiftJournalDetails`
    const body = JSON.stringify({
      journalid: id
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)

    if (resultParsed) {
      let formData = {}
      formData.task_description = resultParsed[0].task_description
      formData.totalAmount = resultParsed[0].sum_total_journal_amount
      formData.journal_id = resultParsed[0].journal_id
      formData.invoice_id = resultParsed[0].invoice_id
      formData.user_uuid = resultParsed[0].user_uuid

      const transformedData = {
        ...formData,
        dateTimeRows: resultParsed.map((item) => ({
          journal_itemid: item.journal_itemid,
          date: item.shift_date,
          startTime: item.shift_start_time,
          endTime: item.shift_endtime,
          // totalHour: item.shift_workedhours,
          amount: item.amount === 0 ? '' : item.amount,
          additionalInfo: item.comments,
          totalAmount: item.sum_total_amount
        }))
      }

      yield put(getJournalEditSuccess(transformedData))
      yield put(updateFormValues('timeReport', transformedData))
    } else {
      yield put(getWorkshiftUserFailed(result.data))
    }
  } catch (error) {
    yield put(getJournalEditFailed(error))
  }
}

function* deleteJournalSaga({ id }) {
  try {
    const url = `${API_SERVER}/DeleteUserWorkShiftJournalDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      journalid: id,
      user: [{ uuid: uuid }]
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Work shift journal details are deleted successfully') {
      yield put(deleteJournalSuccess(result.data))
    } else {
      yield put(deleteJournalFailed(result.data))
    }
    yield put(getJournal())
  } catch (error) {
    yield put(deleteJournalFailed(error))
  }
}

function* updateJournalSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/UpdateUserWorkShiftJournalDetails`
    const uuid = yield select(getUuid)
    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const journal_id = yield select(getJournalId)
    const isEditTimeReportForm_oldData = yield select(getIsEditTimeReportData) // Form data before modified when editing
    // console.log(
    //   'huong isEditTimeReportForm >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
    //   isEditTimeReportForm_oldData
    // )
    const dateTimeRows_oldData = isEditTimeReportForm_oldData.dateTimeRows
    const isRemovedRow = dateTimeRows_oldData.filter(
      (el) =>
        !formValues.dateTimeRows.some(
          (item) => item.journal_itemid === el.journal_itemid
        )
    )
    // Set removed row date to "1900-01-01" for deleting flag
    const formattedRemovedRow = isRemovedRow.map((el) => ({
      ...el,
      date: '1900-01-01T00:00:00'
    }))
    // console.log('huong removed row >>>>>>>>>>>>>>>>>>>', formattedRemovedRow)

    const dateTimeRows_newData = formValues.dateTimeRows

    const dateTimeRows_finalData = [
      ...formattedRemovedRow,
      ...dateTimeRows_newData
    ]

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      workshiftjournals: [
        {
          journalid: journal_id,
          taskdescription: formValues.task_description,
          workshiftjournalitems: dateTimeRows_finalData.map((item) => ({
            shiftdate: moment(item.date).format('YYYY-MM-DD'),
            shiftstarttime: item.startTime,
            shiftendtime: item.endTime,
            shiftworkedhours: item.totalHour,
            amount: item.amount === '' ? 0 : item.amount,
            shiftcomments: item.additionalInfo,
            journalitemid: item.journal_itemid,
            sumtotalamount: item.totalAmount
          }))
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Updated work shift journal details successfully') {
      yield put(updateJournalDetailSuccess(result.data))
    } else {
      yield put(updateJournalDetailFailed(result.data))
    }
    yield put(getJournal())
  } catch (error) {
    yield put(updateJournalDetailFailed(error))
  }
}

export function* watchLoadOpenForWorkSaga() {
  yield takeEvery(LOAD_OPEN_FOR_WORK_START, loadOpenForWorkSaga)
}

export function* watchUpdateOpenForWorkSaga() {
  yield takeEvery(UPDATE_OPEN_FOR_WORK, updateOpenForWorkSaga)
}

export function* watchGetAreaOfExpertiseSaga() {
  yield takeEvery(GET_AREA_OF_EXPERTISE, getAreaOfExpertiseSaga)
}
export function* watchGetAreaOfWorkSaga() {
  yield takeEvery(GET_AREA_OF_WORK, getAreaOfWorkSaga)
}
export function* watchNotOpenForWorkSaga() {
  yield takeEvery(NOT_OPEN_FOR_WORK, notOpenForWorkSaga)
}
export function* watchGetAllAssignmentsSaga() {
  yield takeEvery(GET_ALL_ASSIGNMENTS, getAllAssignmentsSaga)
}
export function* watchSearchAssignmentSaga() {
  yield takeEvery(SEARCH_ASSIGNMENT, searchAssignmentSaga)
}
export function* watchSendApplicationSaga() {
  yield takeEvery(SEND_APPLICATION, sendApplicationSaga)
}
export function* watchTrackApplicationSaga() {
  yield takeEvery(TRACK_APPLICATION, trackApplicationSaga)
}
export function* watchGetAssignmentOfferedSaga() {
  yield takeEvery(GET_ASSIGNMENT_OFFERED_TO_EMAIL, getAssignmentOfferedSaga)
}
export function* watchRejectAssignmentSaga() {
  yield takeEvery(REJECT_ASSIGNMENT, rejectAssignmentSaga)
}
export function* watchGetApplicationProfileSaga() {
  yield takeEvery(GET_APPLICATION_PROFILE, getApplicationProfileSaga)
}
export function* watchSignAndSendAssignmentSaga() {
  yield takeEvery(SIGN_AND_SEND_ASSIGNMENT, signAndSendAssignmentSaga)
}
export function* watchGetWorkshiftUserSaga() {
  yield takeEvery(GET_WORKSHIFT_USER, getWorkshiftUserSaga)
}
export function* watchGetBillableHourUserSaga() {
  yield takeEvery(GET_BILLABLE_HOUR_USER, getBillableHourUserSaga)
}
export function* watchUpdateUserWorkshiftSaga() {
  yield takeEvery(UPDATE_USER_WORKSHIFT, updateUserWorkshiftSaga)
}
export function* watchRequestEditActualHourSaga() {
  yield takeEvery(REQUEST_EDIT_ACTUAL_HOUR, requestEditActualHourSaga)
}
export function* watchGetEmployerWorkshiftSaga() {
  yield takeEvery(GET_EMPLOYER_WORKSHIFT, getEmployerWorkshiftSaga)
}
export function* watchGetJournalSaga() {
  yield takeEvery(GET_JOURNAL, getJournalSaga)
}
export function* watchGetJournalEditSaga() {
  yield takeEvery(GET_JOURNAL_EDIT, getJournalEditSaga)
}
export function* watchDeleteJournalSaga() {
  yield takeEvery(DELETE_JOURNAL, deleteJournalSaga)
}
export function* watchAddJournalDetailSaga() {
  yield takeEvery(ADD_JOURNAL_DETAIL, addJournalDetailSaga)
}
export function* watchUpdateJournalSaga() {
  yield takeEvery(UPDATE_JOURNAL_DETAIL, updateJournalSaga)
}
export function* watchUpdateViewAssignmentSaga() {
  yield takeEvery(UPDATE_VIEW_ASSIGNMENT, updateViewAssignmentSaga)
}
export function* watchPinAssignmentSaga() {
  yield takeEvery(PIN_ASSIGNMENT, pinAssignmentSaga)
}
export function* watchUpdateViewApplicationSaga() {
  yield takeEvery(UPDATE_VIEW_APPLICATION, updateViewApplicationSaga)
}
export function* watchPinApplicationSaga() {
  yield takeEvery(PIN_APPLICATION, pinApplicationSaga)
}
export function* watchUpdateViewWorkshiftSaga() {
  yield takeEvery(UPDATE_VIEW_WORKSHIFT, updateViewWorkshiftSaga)
}
export function* watchPinWorkShiftSaga() {
  yield takeEvery(PIN_WORKSHIFT, pinWorkShiftSaga)
}
